import { fn } from 'storybook/test';

import type { Meta, StoryFn } from '@storybook/react';
import type { OverlayCloseButtonProps } from './OverlayCloseButton';

import { OverlayCloseButton } from './OverlayCloseButton';

import { Container } from 'storyComponents/Container/';

const codeString = '<OverlayCloseButton aria-label={aria-label} onClick={onClickFunction} />';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/OverlayCloseButton',
  component: OverlayCloseButton,
  argTypes: {
    paddedModal: {
      control: 'boolean',
    },
    'aria-label': {
      control: 'text',
    },
  },
  parameters: {
    inspectComponent: OverlayCloseButton,
    codeString: codeString,
  },
} as Meta<OverlayCloseButtonProps>;

const Template: StoryFn<OverlayCloseButtonProps> = (args) => {
  return (
    <Container size="small" padded={false}>
      <OverlayCloseButton {...args} />
    </Container>
  );
};

export const OverlayCloseButtonExample = Template.bind({});
OverlayCloseButtonExample.args = {
  paddedModal: false,
  'aria-label': 'Close',
  onClick: fn(),
};
